export const EMPLOYEE_OPTIONS = [
  {
    label: "10-50",
    value: "kecil",
  },
  {
    label: "51-250",
    value: "menengah",
  },
  {
    label: "251-1000",
    value: "besar",
  },
]

export const EMPLOYEE_TOTAL = [
  { label: 10, value: 10 },
  { label: 50, value: 50 },
  { label: 250, value: 250 },
]
